import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import HeroGuide from "../../Components/HeroGuide/HeroGuide";
import CardsGeneral from "./Components/CardsGeneral";

export default function General() {
  return (
    <LayoutPage
      activeIndex={9}
      navItems={["کد تخفیف"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["مخصوص شما", "برای همه"]}
        hrefs={["/discount", "/discount/general"]}
        activeIndex={1}
      />
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <HeroGuide
          title="با تخفیف خرید کن!"
          h1="کد تخفیف"
          h2="تهیه چالش"
          h3="شرکت در چالش"
          icon1="sale"
          icon2="cart"
          icon3="test"
          text1="کد تخفیف مورد نظر را کپی کرده یا || روی دکمه داخل کوپن بزنید"
          text2="هنگام خرید به تاریخ اعتبار و || چالش‌های مرتبط با تخفیف دقت کنید"
          text3="در چالشی که تهیه کردید شرکت کرده و || مأموریت‌های چالش را پاس کنید"
        />
        <CardsGeneral />
      </div>
    </LayoutPage>
  );
}
